// Student Assessments rebuild (Mudassir, Sep-15): Career Path (student self-assessment) +
// the combined Career/University counselor review. apiClient auto-attaches the Bearer token.
import apiClient from 'src/Common/apiClient'

// Student — state (includes the Personality prerequisite).
export const getMyState = async () => {
  const response = await apiClient.get('/CareerPath/Me/State')
  return response.data
}

// Student — the complete Career Path form (response is { studentId, studentName, questions }).
export const getQuestions = async () => {
  const response = await apiClient.get('/CareerPath/Questions')
  return response.data
}

// Student — submit. answers: [{ questionId, careerPathOptionId }] (one row per selected option).
export const submitCareerPath = async (answers, note) => {
  const response = await apiClient.post('/CareerPath/Me/Submit', { answers, note })
  return response.data
}

// One authorized report (student / parent / counselor).
export const getDetail = async (careerPathReportId) => {
  const response = await apiClient.get('/CareerPath/Detail', { params: { careerPathReportId } })
  return response.data
}

// System career catalog (optional numeric DISC personalityType).
export const getCareers = async (personalityType) => {
  const response = await apiClient.get('/CareerPath/Careers/GetList', {
    params: personalityType != null ? { personalityType } : {},
  })
  const d = response.data
  return Array.isArray(d) ? d : d?.items ?? []
}

// History lists.
export const getMyList = async () => {
  const response = await apiClient.get('/CareerPath/Me/GetList/lookup')
  const d = response.data
  return Array.isArray(d) ? d : d?.items ?? []
}
export const getStudentList = async (studentId) => {
  const response = await apiClient.get('/CareerPath/Student/GetList/lookup', {
    params: { studentId },
  })
  const d = response.data
  return Array.isArray(d) ? d : d?.items ?? []
}
export const getParentStudentList = async (studentId) => {
  const response = await apiClient.get('/CareerPath/Parent/Student/GetList/lookup', {
    params: { studentId },
  })
  const d = response.data
  return Array.isArray(d) ? d : d?.items ?? []
}

// Counselor combined Career + University review — load and submit one decision for both.
export const getCombinedReview = async (careerPathReportId) => {
  const response = await apiClient.get('/CareerPath/Student/Review', {
    params: { careerPathReportId },
  })
  return response.data
}

// workflowStatus 4 (approve) or 5 (return). Approve needs >=1 career, >=1 university, a reason.
export const submitCombinedReview = async (careerPathReportId, payload) => {
  const response = await apiClient.put('/CareerPath/Student/Review', payload, {
    params: { careerPathReportId },
  })
  return response.data
}

// Final Student Report. Counselor and student use /Final-Report; a logged-in Parent
// (localStorage 'role') uses the parent-scoped route. suppressErrorToast lets the caller
// own the not-ready / error UI (e.g. the soft "report not ready yet" state) instead of a toast.
export const getFinalReport = async (studentId, careerPathReportId) => {
  const isParent = localStorage.getItem('role') === 'Parent'
  const url = isParent ? '/CareerPath/Parent/Final-Report' : '/CareerPath/Final-Report'
  const response = await apiClient.get(url, {
    params: { studentId, careerPathReportId },
    suppressErrorToast: true,
  })
  return response.data
}
